import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { DataService } from 'src/app/services/data.service';
import { NwbAlertService } from '@wizishop/ng-wizi-bulma';
import * as moment from 'moment';
import { createAlertConfig } from 'src/app/shared/factoryconfigAlert';
import { NgForm } from '@angular/forms';
import { AlertDurationWithRedirect } from 'src/app/shared/constant.shared';

@Component({
  selector: 'modify-socio',
  templateUrl: './modify-socio.component.html',
  styleUrls: ['./modify-socio.component.css']
})
/** modifySocio component*/
export class ModifySocioComponent implements OnInit {

  socio: any;
  associazione: any;

  dateModel: Date;

  nazioni: any[];
  associazioni: any[];

  @ViewChild('modifySocioForm', { static: true })
  formToSend: NgForm;

  /** modifySocio ctor */
  constructor(private dataService: DataService, private alertservice: NwbAlertService, private route: ActivatedRoute, private router: Router) {

  }

  ngOnInit(): void {
    this.route.data.subscribe(t => {
      this.nazioni = t.data[0];
      this.associazioni = t.data[1];

      this.socio = t.dataSocio;
      if (this.socio.natoIl) {
        this.dateModel = new Date(this.socio.natoIl);
        let m = moment(this.dateModel);
      }
    });
  }
  
  modifySocio() {
    if (this.formToSend.invalid) {
      this.alertservice.open(createAlertConfig("Controllare i campi", false)).afterClosed().subscribe();
      return;
    }
    let m = moment(this.dateModel);
    this.socio.natoIl = m.format('YYYY-MM-DD');

    this.dataService.setSocioGestito(this.socio).subscribe(() => {
      this.alertservice.open(createAlertConfig("Anagrafica aggiornata", true, AlertDurationWithRedirect)).afterClosed().subscribe(t => {
        this.router.navigate(['/area-utente', 'gruppo']);
      });
    });
  }

  onChangeAssociazione(event: any) {
    if (event) {
      let associazioneNuova = this.associazioni.find(a => a.id == event);
      this.socio.idAssociazione = associazioneNuova.id;
      this.socio.nomeAssociazione = associazioneNuova.ragioneSociale;
    } else {
      this.socio.idAssociazione = this.socio.tesseraAssociazione = this.socio.nomeAssociazione = undefined;
    }
  }
}
